function AdminSignOut() {
  localStorage.clear();
  window.location.href='/backend/public/admin/users';
  return (
      <> </>
  )
}

export default AdminSignOut;